import Swiper, {Autoplay, Manipulation, Navigation} from 'swiper';

const bikesSlider = new Swiper('.bikes-slider', {
    modules: [
        Autoplay,
        Navigation,
        Manipulation,
    ],
    slidesPerView: 1,
    centeredSlides: true,
    rewind: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.bikes-slider__next',
        prevEl: '.bikes-slider__prev',
    },
    breakpoints: {
        1024: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2,
        }
    }
});

// Handle filters
const filters = [...document.querySelectorAll('.bikes-slider__filters li')];
const slides = [...bikesSlider.slides];
filters.forEach(filter => {
    filter.addEventListener('click', () => {
        filters.forEach(filter => filter.classList.remove('active'));
        filter.classList.add('active');
        const filterValue = filter.dataset.bikeFilter?.toUpperCase() ?? '';
        const isCurrentFilter = bikesSlider.slides.every(slide => slide.dataset.bikeFilter?.toUpperCase() === filterValue);

        if (isCurrentFilter) return;

        bikesSlider.removeAllSlides();
        bikesSlider.appendSlide(slides);

        const slidesToRemove = slides.reduce((acc, slide, index) => {
            const slideFilter = slide.dataset.bikeFilter?.toUpperCase() ?? '';
            if (filterValue !== 'ALL' && slideFilter !== filterValue) {
                acc.push(index);
            }

            return acc;
        }, []);

        if (slidesToRemove.length > 0) {
            bikesSlider.removeSlide(slidesToRemove);
            bikesSlider.update();
            bikesSlider.slideTo(0);
        } else {
            bikesSlider.update();
        }

        bikesSlider.autoplay.start();
    });
});
